var map = {
	"./template-img1.png": "3d10",
	"./template-img2.png": "5d26",
	"./template-img3.png": "a377",
	"./template-img4.png": "ef39",
	"./template-img5.png": "e1c1",
	"./template-img6.png": "b629"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3892d";